import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { TableCellComponent } from '@captiveaire/table';
import { IDeviceStatusListSummary } from '../shared/models/device-status-list-summary.interface';

@Component({
    selector: 'dl-device-status-modbus-id-cell',
    templateUrl: './device-status-modbus-id-cell.component.html'
})
export class DeviceStatusModbusIdCellComponent extends TableCellComponent implements OnInit {
    public static $name: string = 'clDeviceStatusModbusIdCell';

    @Input() public item: IDeviceStatusListSummary;

    public modbusIdCellFormGroup: FormGroup;
    public modbusIdFormControl: FormControl;

    public ngOnInit() {
        this.modbusIdCellFormGroup = new FormGroup({});
        this.modbusIdFormControl = new FormControl(this.item.modbusId);
        this.modbusIdCellFormGroup.addControl('modbusId', this.modbusIdFormControl);
    }

    public updateModbusId() {
        this.item.modbusId = this.modbusIdFormControl.value;
    }
}
